import Vue from 'vue'
import Modal from '../components/common/DcModal'
import EstimateModal from '../components/top/input/estimate/DcEstimateModal'
import SheetPreviewModal from '../components/top/input/estimate/SheetPreviewModal'
import ImageViewer from '../components/top/product/common/ImageViewer'
import ImageSlide from '../components/top/product/common/ImageSlide'
import InviteUserModal from '../components/user/InviteUserModal'
import UserEditModal from '../components/user/DcUserEditModal'
import SaveModal from '../components/common/DcSaveModal'
import DcCameraPositionModal from '../components/output/DcCameraPositionModal'
import DcProductSearch from '../components/top/input/search/DcProductSearchModal'
import DcPaymentSelect from '../components/top/input/order/DcPaymentSelectModal'
import DcSaveProductSearch from '../components/top/input/search/DcSaveProductSearchModal'
// import { VueAwesomeSwiper } from 'vue-awesome-swiper'

/**
 * 共通モーダル表示
 * 利用方法：
 * let modalData = {
 *   title: 'タイトル',
 *   messages: ['メッセージ', '複数項目に分けて引渡すと改行して表示する'],
 *   modalType: 'message', // or 'confirm'
 *   messageType: 'info', // or 'success' or 'error'
 *   textAlign: 'center', // or 'left'
 *   onOk: () => { OKボタン押下時のコールバック関数を定義 },
 *   onCancel: () => { キャンセルボタン押下時のコールバック関数を定義 },
 *   callbackParams: { コールバック関数に渡す引数を定義 }
 * }
 * App.showModal(modalData)
 */
export const showModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-modal': Modal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-modal
        :title="modalData.title"
        :messages="modalData.messages"
        :modalType="modalData.modalType"
        :messageType="modalData.messageType"
        :textAlign="modalData.textAlign"
        :okBtnLabel="modalData.okBtnLabel"
        :cancelBtnLabel="modalData.cancelBtnLabel"
        :onOk="modalData.onOk"
        :onCancel="modalData.onCancel"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 見積り/図面モーダル */
export const showEstimateModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-estimate-modal': EstimateModal },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-estimate-modal ref="estimateModalRef"
        :onOk="modalData.onOk"
        :onOutputCG="modalData.onOutputCG"
        :showSuccess="modalData.showSuccess"
        :fileName="modalData.fileName"
        :titleDoor="modalData.titleDoor"
        :colorDoor="modalData.colorDoor"
        :titleCabine="modalData.titleCabine"
        :colorCabine="modalData.colorCabine"
        :titleCounter="modalData.titleCounter"
        :colorCounter="modalData.colorCounter"
        :priceData="modalData.priceData"
        :targetPlan="modalData.targetPlan"
        :spaceJoincd="modalData.spaceJoincd"
        :dispOrderButton="modalData.dispOrderButton"
        :dcProductCount="modalData.dcProductCount"
        :isCalcDelivery="modalData.isCalcDelivery"
        :isDrawing="modalData.isDrawing"
        :makerData="modalData.makerData"
        :isProductData="modalData.isProductData"
        :resrchFlag="modalData.resrchFlag"
        :consentImg="modalData.consentImg"
        :isNetPrice="modalData.isNetPrice"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 施工例ポップアップ */
export const showImageViewerModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-image-viewer-modal': ImageViewer },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-image-viewer-modal ref="imageViewerModalRef"
        :image="modalData.image"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 図面/製造指示書プレビュー */
export const showPreview = (modalData) => {
  let modal = new Vue({
    el: '#preview-modal',
    components: { 'dd-sheet-modal': SheetPreviewModal },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-sheet-modal ref="previewModalRef"
        :spaceJoincd="modalData.spaceJoincd"
        :isShowInfo="modalData.isShowInfo"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 招待メール */
export const showInviteUserModal = () => {
  let modal = new Vue({
    el: '#mail-modal',
    components: { 'dd-invite-user-modal': InviteUserModal },
    data () {
      return {
      }
    },
    methods: {
    },
    template: `
      <dd-invite-user-modal
      />
    `
  }).$children[0]
  modal.showModal()
}

/** ユーザーに関する処理のモーダル表示 */
export const showUserModal = (modalData) => {
  let modal = new Vue({
    el: '#add-user-modal',
    components: { 'dd-user-modal': UserEditModal },
    data () {
      return {
        userObj: modalData.userObj
      }
    },
    template: `
      <dd-user-modal ref="userModalRef"
        :userObj="userObj"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 商品情報を名前をつけて保存する */
export const showProductSave = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-save-modal': SaveModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-save-modal ref="saveModalRef"
        :title="modalData.title"
        :messages="modalData.messages"
        :modalType="modalData.modalType"
        :textAlign="modalData.textAlign"
        :okBtnLabel="modalData.okBtnLabel"
        :onOk="modalData.onOk"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** 商品情報を名前をつけて保存する */
export const showCameraPosModal = (modalData) => {
  let modal = new Vue({
    el: '#camera-position-modal',
    components: { 'dd-camera-position-modal': DcCameraPositionModal },
    data () {
      return {
        modalData: modalData
      }
    },
    template: `
      <dd-camera-position-modal ref="cameraPositionModalRef"
        :onOk="modalData.onOk"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

/** マニュアルプレビュー */
export const showImageSlideModal = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'dd-image-slide-modal': ImageSlide },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <dd-image-slide-modal ref="imageSlideModalRef"
        :imageList="modalData.imageList"
        :swiperOptions="modalData.swiperOptions"
      />
    `
  }).$children[0]
  modal.showModal()
}

export const showProductSearch = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'product-search': DcProductSearch },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <product-search ref="productSearchRef"
        :categoryList="modalData.categoryList"
        :onOk="modalData.onOk"
        :onCancel="modalData.onCancel"
        :isHaseko="modalData.isHaseko"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

export const showPaymentSelect = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'payment-select': DcPaymentSelect },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <payment-select ref="paymentSelectRef"
        :onOk="modalData.onOk"
        :paymentType="modalData.paymentType"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}

export const showSaveProductSerach = (modalData) => {
  let modal = new Vue({
    el: '#modal',
    components: { 'save-product-search': DcSaveProductSearch },
    data () {
      return {
        modalData: modalData
      }
    },
    methods: {
    },
    template: `
      <save-product-search ref="productSearchRef"
        :saveList="modalData.saveList"
        :onOk="modalData.onOk"
        :onCancel="modalData.onCancel"
        :callbackParams="modalData.callbackParams"
      />
    `
  }).$children[0]
  modal.showModal()
}



// WEBPACK FOOTER //
// ./src/main/js/payment/utils/AppEc.js